import { render, staticRenderFns } from "./aSegmentationReportOccupancyChart.vue?vue&type=template&id=72a4d4c6"
import script from "./aSegmentationReportOccupancyChart.vue?vue&type=script&lang=js"
export * from "./aSegmentationReportOccupancyChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports